import styles from "./ContextMenu.module.css";
import { ContextMenuPosition } from "../../types";

interface ContextMenuProps {
    position: ContextMenuPosition;
    onClose: () => void;
    onAddIncident: () => void;
    onAddContainerPlatforms: () => void;
    onAddGarage: () => void;
    onAddTbo: () => void;
}

export default function ContextMenu({ position, onClose, onAddIncident, onAddContainerPlatforms, onAddGarage,  onAddTbo,}: ContextMenuProps) {
    return (
        <div
            className={styles.menu}
            style={{ top: position.y, left: position.x }} // позиция — ок оставлять inline
            onMouseLeave={onClose}
        >
            <div
                className={styles.item}
                onClick={() => {
                    onAddContainerPlatforms();
                    onClose();
                }}
            >
                <span className={styles.icon}>➕</span>
                Добавить контейнерную площадку
            </div>
            <div
                className={styles.item}
                onClick={() => {
                    onAddGarage();
                    onClose();
                }}
            >
                <span className={styles.icon}>➕</span>
                Добавить гараж
            </div>
            <div
                className={styles.item}
                onClick={() => {
                    onAddIncident();
                    onClose();
                }}
            >
                <span className={styles.icon}>➕</span>
                Добавить инцидент
            </div>
            <div
                className={styles.item}
                onClick={() => {
                    onAddTbo();
                    onClose();
                }}
            >
                <span className={styles.icon}>➕</span>
                Добавить ТБО
            </div>
        </div>
    );
}
